"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyToClipboard = copyToClipboard;
exports.pasteFromClipboard = pasteFromClipboard;

var _isNil = _interopRequireDefault(require("lodash/isNil"));

function deserializeSnippet(value) {
  var dirty = false;
  var quotes = 0;
  var start = 0;
  var end = 0;
  var row = [];
  var out = [];

  var push = function push() {
    var cell = value.substring(start, end);
    var cellUnescaped = cell.includes('\t') || cell.includes('\n') ? value.substring(1, cell.length - 1).replace(/""/g, '"') : value.substring(start, end);
    row.push(cellUnescaped);
  };

  var flush = function flush() {
    out.push(row);
    row = [];
  };

  value.split('').forEach(function (char, idx) {
    if (char === '"') {
      end += 1;
      quotes += 1;
    } else if (char === '\n' && quotes % 2 === 0) {
      push();
      flush();
      start = idx + 1;
      end = start;
    } else if (char === '\t' && quotes % 2 === 0) {
      push();
      start = idx + 1;
      end = start;
      dirty = true;
    } else if (char !== '\r' || quotes % 2 !== 0) {
      dirty = false;
      end += 1;
    }
  }); // If there's any straggling data from a malformed clipboard value, push the results.
  // Also, if we've hit a tab and haven't seen a newline yet, push anyway.

  if (start !== end || dirty) {
    push();
  } // Flush the last row if there's anything yet to be submitted.


  if (row.length > 0) {
    flush();
  }

  return out;
}

function serializeCell(cell) {
  if (typeof cell !== 'string') {
    // `cell` can occasionally be null, so it should default to an empty string.
    return (0, _isNil.default)(cell) ? '' : cell.toString();
  }

  var hasNewLines = cell.includes('\n');
  var hasTabs = cell.includes('\t');

  if (hasNewLines || hasTabs) {
    var escapedCell = cell.replace(/"/, '""');
    return "\"".concat(escapedCell, "\"");
  }

  return cell;
}

function serializeRow(row) {
  return row.map(serializeCell).join('\t');
}

function serializeSnippet(snippet) {
  return snippet.map(serializeRow).join('\n');
}

function copyToClipboard(snippet) {
  // Create a text area to insert the text into and hide it off of the page.
  var textArea = document.createElement('textarea');
  textArea.style.cssText = 'position:absolute; left: -100px; width: 100px';
  textArea.value = serializeSnippet(snippet);
  textArea.setAttribute('readonly', true); // Insert the text area into the document, select the text, and then copy it.

  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('copy'); // Remove the textarea because we don't need it anymore.

  textArea.remove();
}

function pasteFromClipboard(value) {
  return deserializeSnippet(value);
}